/*
 * @Date: 2022-09-14 09:59:31
 * @LastEditors: kinfai
 * @Description: axios配置
 * @LastEditTime: 2022-09-14 10:07:05
 * @FilePath: \my-app\src\axios\index.js
 */
import axios from "axios";
import useTourists from "../hooks/tourists/index.js";


const service = axios.create({
    baseURL: process.env.REACT_APP_API,
    timeout: 30000,
})

// 请求拦截器
service.interceptors.request.use(config => {
    const {getBaseInfo} = useTourists()
    const {touristsId, companyId} = getBaseInfo()
    // console.log(getBaseInfo(), "getBaseInfo")
    if (config.method === undefined) {
        config.method = "get";
    }
    if (config.data === undefined) {
        config.data = {};
    }

    // 判断是否需要带上 公司id和游客id
    if (config.isCompany) {
        config.data.company_sfid = companyId
    }
    if (config.isTourists) {
        config.data.browser_sfid = touristsId
        config.data.send_sfid = touristsId
    }

    if (config.method === "get" || config.method === "delete") {
        config.params = config.data || {};
    }
    if (["PUT", "POST", "PATCH"].indexOf(config.method.toUpperCase()) !== -1) {
        config.data = config.data || {};
    }

    return config;
})

// 响应拦截器
service.interceptors.response.use(res => {

    if (res.data.code === 200) {
        return res.data
    }else{
        return Promise.reject(res)
    }
}, error => {
    return Promise.reject(error.response);
})

export default service
